import React, { useEffect, useState, memo } from 'react'
import { useApi } from 'shared-ui/api/ApiContext'
import { Checkbox } from '~components/page/AzurePipelines/components/Checkbox'
import { Loader } from '~components/page/AzurePipelines/components/Loader'

// Use memo to prevent unnecessary re-renders
function MarketCard({ env, market, selected, onToggle, collectStats }) {
  const { code, name, members = 0, url, flag, version = 'v –', host } = market

  const api = useApi()
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState({})
  // const [error, setError] = useState(false)

  useEffect(() => {
    async function fetchData() {
      setLoading(true)
      // setError(false) // Reset error state before fetching
      try {
        const { request } = await api.getMarketStats(url)
        const response = await request
        setData(response)
        setLoading(false)
      } catch (e) {
        console.log('Error fetching market stats:', e)
        // setError(true) // Set error state when an error occurs
        setLoading(false)
      }
    }

    try {
      collectStats && fetchData()
    } catch (e) {
      console.error('Error fetching market stats:', e)
      // setError(true) // Set error state when an error occurs
      setLoading(false)
    }
  }, [collectStats, env])

  const showRedTint = collectStats && !loading && Object.keys(data).length < 1

  // Use React.memo to prevent unnecessary re-renders
  return (
    <div
      className={`relative cursor-pointer overflow-hidden rounded-lg border border-b-0 border-r-0 border-white/20 ${
        showRedTint &&
        'bg-gradient-to-br from-white/40 to-gray-100/30 before:absolute before:inset-0 before:bg-red-500/5'
      } shadow-sm backdrop-blur-sm transition-all duration-200 hover:bg-white/60 hover:shadow-md ${selected ? 'bg-white/60' : ''}`}
      onClick={e => {
        // Prevent event bubbling
        e.stopPropagation()
        onToggle(code)
      }}
    >
      {/*<Loader />*/}
      {loading && <Loader />}

      <div className="flex items-center pl-4">
        <Checkbox
          className={
            "${selected ? 'bg-accent-400 shadow-lg' : 'bg-white/70'} z-10 flex h-5 w-5 items-center justify-center rounded-full transition-all"
          }
          key={code}
          // label={'BUILD'}
          checked={selected}
          onChange={e => {
            e.stopPropagation()
            onToggle(code)
          }}
        />
        <div className="flex w-1/4 items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100 p-4">
          <div className="text-[28px]">{flag}</div>
        </div>
        <div className="p-4">
          <div className="flex items-center gap-4">
            <div className="flex flex-col">
              <div className="flex items-center gap-2">
                <span className="text-lg font-medium text-gray-800">{name}</span>
                {data?.version && (
                  <span className="rounded border-[1px] border-b-0 border-r-0 border-white/20 bg-blue-100 px-1 py-[1px] text-[10px] font-medium text-blue-600 shadow backdrop-blur">
                    v{data.version}
                  </span>
                )}
              </div>
              <span className="text-sm font-medium text-gray-500">{host}</span>
            </div>
          </div>
          <div className="mt-2 flex items-center justify-between">
            {data?.active >= 0 && (
              <span className="text-xs text-gray-600">
                {`${data.active} ${data?.registered && `/ ${data.registered}`} members`}
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

// Export the memoized component
export default memo(MarketCard)
